export default __webpack_public_path__ + "static/media/no_image_rect.aa92d75d.png";